export const prefersDarkQuery = "(prefers-color-scheme: dark)";

export const getSystemTheme = () => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return "light";
  }

  return window.matchMedia(prefersDarkQuery).matches ? "dark" : "light";
};

export const getSystemLanguage = () => {
  const lang = navigator.language?.toLowerCase() || "en";

  if (lang.startsWith("es")) return "es";
  if (lang.startsWith("en")) return "en";

  return "en";
};

export const getSystemTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
};

export const resolveThemePreference = (value) => {
  return value === "system" ? getSystemTheme() : value || "light";
};

export const resolveLanguagePreference = (value) => {
  return value === "system" ? getSystemLanguage() : value || "es";
};

export const resolveTimezonePreference = (value) => {
  return value === "system" ? getSystemTimezone() : value || "UTC";
};
